export default "/build/frontend/fonts/vendor/@fontsource/inter/files/inter-greek-ext-400-normal.woff?b9e1e89444a313a63b9197617516264d";